import { render, staticRenderFns } from "./Commentaries.vue?vue&type=template&id=0c866974&"
import script from "./Commentaries.vue?vue&type=script&lang=js&"
export * from "./Commentaries.vue?vue&type=script&lang=js&"
import style0 from "./Commentaries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports